export default __webpack_public_path__ + "static/media/maxine_front.c3c872a9.jpg";